import { waitFor, settled } from '@ember/test-helpers';
import { collection, text, clickable, isPresent } from 'ember-cli-page-object';
import { getter } from 'ember-cli-page-object/macros';

const successAlertSelector = '[data-test-flash-type="success"]';
const errorAlertSelector = '[data-test-flash-type="error"]';
const infoAlertSelector = '[data-test-flash-type="info"]';

const bodySelector = '[data-test-flash-type]';
const contentSelector = '[data-test-flash-content]';
const actionSelector = '[data-test-flash-action]';
const titleSelector = '[data-test-flash-message]';
const dismissButtonSelector = '.hds-dismiss-button';

export default {
  successAlert: isPresent(successAlertSelector),
  errorAlert: isPresent(errorAlertSelector),
  infoAlert: isPresent(infoAlertSelector),
  latestMessage: getter(function () {
    let { content, dismiss, title } = this.latestItem;
    return { content, dismiss, title };
  }),
  latestItem: getter(function () {
    let count = this.messages.length;
    return this.messages.objectAt(count - 1);
  }),
  messages: collection(bodySelector, {
    click: clickable(actionSelector),
    content: text(contentSelector),
    title: text(titleSelector),
    dismiss: clickable(dismissButtonSelector),
  }),
  waitForFlash() {
    return waitFor(bodySelector);
  },
  clickLast() {
    return this.latestItem.click();
  },
  async clickAll() {
    for (let message of this.messages) {
      message.click();
    }
    await settled();
  },
};
